import { AuthGuard } from '@/components/shared/AuthGuard'
import { initPostHog } from '@/lib/posthog'
import ContactPage from '@/pages/ContactPage'
import DashboardPage from '@/pages/DashboardPage'
import DrillPage from '@/pages/DrillPage'
import FeedbackPage from '@/pages/FeedbackPage'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage'
import InterviewSessionPage from '@/pages/InterviewSessionPage'
import InterviewSetupPage from '@/pages/InterviewSetupPage'
import LandingPage from '@/pages/LandingPage'
import LoginPage from '@/pages/LoginPage'
import PartnershipsPage from '@/pages/PartnershipsPage'
import PrivacyPage from '@/pages/PrivacyPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import SampleReportsPage from '@/pages/SampleReportsPage'
import SettingsPage from '@/pages/SettingsPage'
import StoryBankPage from '@/pages/StoryBankPage'
import StoryIntakePage from '@/pages/StoryIntakePage'
import SupportActionPage from '@/pages/SupportActionPage'
import TermsPage from '@/pages/TermsPage'
import { useAuthStore } from '@/stores/authStore'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

initPostHog()

export default function App() {
  const { initialize } = useAuthStore()

  useEffect(() => {
    initialize()
  }, [initialize])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/interview/setup"
          element={
            <AuthGuard>
              <InterviewSetupPage />
            </AuthGuard>
          }
        />
        <Route
          path="/interview/session/:sessionId"
          element={
            <AuthGuard>
              <InterviewSessionPage />
            </AuthGuard>
          }
        />
        <Route
          path="/feedback/:sessionId"
          element={
            <AuthGuard>
              <FeedbackPage />
            </AuthGuard>
          }
        />
        <Route
          path="/settings"
          element={
            <AuthGuard>
              <SettingsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/drill"
          element={
            <AuthGuard>
              <DrillPage />
            </AuthGuard>
          }
        />
        <Route
          path="/story-bank"
          element={
            <AuthGuard>
              <StoryBankPage />
            </AuthGuard>
          }
        />
        <Route
          path="/story-intake"
          element={
            <AuthGuard>
              <StoryIntakePage />
            </AuthGuard>
          }
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/sample-reports" element={<SampleReportsPage />} />
        <Route path="/partnerships" element={<PartnershipsPage />} />
        <Route path="/support-action" element={<SupportActionPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  )
}
